import { render, staticRenderFns } from "./MtipobultoForm.vue?vue&type=template&id=461287d0"
import script from "./MtipobultoForm.vue?vue&type=script&lang=js"
export * from "./MtipobultoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports